import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3153313e")

_pushScopeId("data-v-3153313e")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-grow flex flex-col justify-between h-screen" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "一斉メッセージ", -1)
const _hoisted_4 = { class: "flex-grow flex flex-col items-center bg-primary-100 overflow-y-scroll pt-12" }
const _hoisted_5 = { class: "panel-container rounded-md bg-white pb-2 mb-16 lg:mb-8" }
const _hoisted_6 = { class: "table-header-color w-full px-4 py-3 flex items-center justify-end lg:justify-between" }
const _hoisted_7 = { class: "hidden lg:flex mr-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "グループ作成", -1)
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-8"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "text-gray-500 text-sm" }, "グループ情報取得中...", -1)
const _hoisted_11 = {
  key: 1,
  class: "flex"
}
const _hoisted_12 = { class: "flex-grow flex flex-col justify-between h-screen" }
const _hoisted_13 = { class: "flex-grow flex items-start justify-center bg-primary-100 overflow-y-auto px-4 pt-12" }
const _hoisted_14 = { class: "w-full max-w-2xl rounded-md bg-white px-6 py-10 text-center shadow-sm" }
const _hoisted_15 = /*#__PURE__*/_createVNode("h1", { class: "text-xl font-bold text-gray-800" }, " グループ管理画面が移動しました ", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "mt-4 text-gray-600 leading-7" }, [
  /*#__PURE__*/_createTextVNode(" グループの確認・作成・編集・CSV一括登録は、"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" スクールAIの生徒管理画面から行えます。 ")
], -1)
const _hoisted_17 = { class: "mt-8 flex justify-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_m_loading_icon = _resolveComponent("m-loading-icon")
  const _component_m_table = _resolveComponent("m-table")
  const _component_ms_add_group_modal = _resolveComponent("ms-add-group-modal")
  const _component_ms_edit_group_modal = _resolveComponent("ms-edit-group-modal")
  const _component_ms_send_modal = _resolveComponent("ms-send-modal")

  return (_ctx.isStudyRoomOnly)
    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_MNavBar),
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_MHeaderPanel, {
              title: "生徒情報",
              breadcrumbs: [],
              tabs: _ctx.tabs,
              "current-tab-index": _ctx.currentTabIndex
            }, {
              actions: _withId(() => [
                _createVNode(_component_m_button, {
                  color: "secondary-500",
                  "hover-color": "secondary-600",
                  outline: "",
                  onClick: _ctx.showSendModal
                }, {
                  default: _withId(() => [
                    _createVNode(_component_m_icon, {
                      type: "send",
                      class: "mr-2 transform rotate-90 z-0"
                    }),
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["tabs", "current-tab-index"]),
            _createVNode("main", _hoisted_4, [
              _createVNode("section", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchKeyword = $event)),
                      type: "search",
                      name: "searchGroup",
                      placeholder: "グループ名で検索...",
                      class: "w-60 bg-white rounded border border-white focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
                    }, null, 512), [
                      [_vModelText, _ctx.searchKeyword]
                    ])
                  ]),
                  _createVNode(_component_m_button, {
                    color: "primary-500",
                    "hover-color": "primary-600",
                    onClick: _ctx.showAddModal
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_m_icon, {
                        type: "plus",
                        width: "4",
                        class: "mr-2"
                      }),
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                (_ctx.load)
                  ? (_openBlock(), _createBlock("div", _hoisted_9, [
                      _createVNode(_component_m_loading_icon),
                      _hoisted_10
                    ]))
                  : (_openBlock(), _createBlock(_component_m_table, {
                      key: 1,
                      datas: _ctx.filteredDatas,
                      definitions: _ctx.definitions,
                      "count-per-page": 40,
                      "default-sort-key": "studentNum",
                      editable: "",
                      onSelect: _ctx.showEditModal
                    }, null, 8, ["datas", "definitions", "onSelect"]))
              ])
            ])
          ])
        ]),
        (_ctx.isDisplayedAddGroupModal)
          ? (_openBlock(), _createBlock(_component_ms_add_group_modal, {
              key: 0,
              "custom-properties": _ctx.customProperties,
              onClose: _ctx.closeAddModal
            }, null, 8, ["custom-properties", "onClose"]))
          : _createCommentVNode("", true),
        (_ctx.isDisplayedEditGroupModal && _ctx.selectedGroup)
          ? (_openBlock(), _createBlock(_component_ms_edit_group_modal, {
              key: 1,
              "custom-properties": _ctx.customProperties,
              group: _ctx.selectedGroup,
              onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDisplayedEditGroupModal = false))
            }, null, 8, ["custom-properties", "group"]))
          : _createCommentVNode("", true),
        (_ctx.isDisplayedSendModal)
          ? (_openBlock(), _createBlock(_component_ms_send_modal, {
              key: 2,
              schools: _ctx.schools,
              classrooms: _ctx.classrooms,
              students: _ctx.students,
              groups: _ctx.groups,
              onClose: _ctx.closeSendModal
            }, null, 8, ["schools", "classrooms", "students", "groups", "onClose"]))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createBlock("div", _hoisted_11, [
        _createVNode(_component_MNavBar),
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_MHeaderPanel, {
            title: "生徒情報",
            breadcrumbs: [],
            tabs: _ctx.tabs,
            "current-tab-index": _ctx.currentTabIndex
          }, null, 8, ["tabs", "current-tab-index"]),
          _createVNode("main", _hoisted_13, [
            _createVNode("section", _hoisted_14, [
              _hoisted_15,
              _hoisted_16,
              _createVNode("div", _hoisted_17, [
                _createVNode("a", {
                  href: _ctx.newGroupManagementUrl,
                  class: "inline-flex items-center rounded-md font-medium text-sm transition-all duration-300 px-4 py-2 text-white bg-primary-500 hover:bg-primary-600 cursor-pointer"
                }, " 新しいグループ管理画面を開く ", 8, ["href"])
              ])
            ])
          ])
        ])
      ]))
})